import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import i18n from './i18n/i18n'
import "amfe-flexible";
import "@/assets/css/font.css";
import "@/assets/css/reset.css";
import "@/assets/css/docs.less";
import { Toast, Dialog } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/dialog/style';

import Vconsole from 'vconsole'
const app = createApp(App);

if (process.env.VUE_APP_ENV !== "production") {
    let vConsole = new Vconsole()
    app.use(vConsole)
}


app.use(Toast);
app.use(Dialog);
app.use(router).use(i18n);
app.directive('version', {
    mounted(el, binding) {
        // console.log(el)
        // console.log(binding)
        // vpa_android_0
        let version = localStorage.getItem('version');
        let source = localStorage.getItem('source') == '1' ? 'vpa' : 'wear3'; // 1：VPA（wear2） 2：wear3
        let oversea = localStorage.getItem('oversea'); //0：国内 1：海外
        let platform = sessionStorage.getItem('isiOS') === 'true' ? 'ios' : 'android'; //1：iOS 2：Android
        let currentName = source + '_' + platform + '_' + oversea;
        // console.log(currentName, version)
        if(binding.value[currentName]) {
            let minVersion = binding.value[currentName]; // 显示的最低版本
            if(minVersion > version) {
                el.style = "display: none"
            }
            // console.log(minVersion)
        }
    }
})
app.mount('#app');
